import _ from "underscore";

export const order = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
  NONE: undefined,
};

export function getNextOrdering(ordeingType) {
  if (ordeingType === order.NONE) return order.ASCENDING;
  if (ordeingType === order.ASCENDING) return order.DESCENDING;
  if (ordeingType === order.DESCENDING) return order.NONE;
  return order.NONE;
}

export function orderTable(items, tableInfo) {
  if (
    tableInfo.columnOrdering.key == "" ||
    tableInfo.columnOrdering.order == order.NONE
  )
    return items;

  let getValueFunc;
  let keys = tableInfo.columnOrdering.key.split(".");

  if (keys.length === 2) getValueFunc = getValue2;
  else if (keys.length === 1) {
    getValueFunc = getValue;
    keys.push("");
  }

  items = _.sortBy(items, (item) => {
    return getValueFunc(item, keys[0], keys[1]);
  });

  if (tableInfo.columnOrdering.order == order.DESCENDING) {
    return items.reverse();
  }

  return items;
}

function getValue(object, key1) {
  return object[key1];
}

function getValue2(object, key1, key2) {
  return object[key1][key2];
}

export default orderTable;
